export default __webpack_public_path__ + "static/media/activitytab-tickets.49ec30a8.svg";